import * as React from "react"
import { useRecoilValue } from "recoil"
import { SDKContext } from "../../../context/SDKContext"
import { StyledHeartIcon } from "./buttons-main-screen.styled"
import { saveConfigAvatarAtom } from "../../../recoil/atoms/avatar"
import { convertСonfig } from "../../views/home/AvatarsModal/utils"
import { brandingSelector } from "../../../recoil/atoms/room"
import { useHeartAnimation } from "../../../hooks/useHeartAnimation"
import { useWatchParty } from "../../../hooks/useWatchParty"
import { IconButton } from "../../common/buttons"
import { viewDependingLayoutAtom } from "../../../recoil/atoms/view"
import { HeartIconProps } from "./buttons-main-screen.interface"
import { addHitAreaStyle } from "../../../util/styleUtils"
import emojiReactionAnimation from "../small-view/reactions/emoji"

const UserType = window.MeetOnline?.UserType

export const HeartIcon: React.FC<HeartIconProps> = ({
  showIcon,
  isMobile,
  localUserProperties,
  changeSizeIconDependingHeightVideo
}) => {
  const { isTransparent, isLandscape } = useRecoilValue(viewDependingLayoutAtom)
  const roomStyles = useRecoilValue(brandingSelector)
  const config = useRecoilValue(saveConfigAvatarAtom)
  const meetingClient = React.useContext(SDKContext)
  const { watchPartyHostId, isWatchParty, isModPresentVideo } = useWatchParty()

  const profileImageUrl = React.useMemo(
    () => roomStyles.roomAvatarImage ?? "",
    [roomStyles.roomAvatarImage]
  )

  const handleLike = React.useCallback(
    e => {
      e.stopPropagation()

      meetingClient?.userEventLog.submitHeartButtonClickEvent()

      if (config !== "") {
        const data = convertСonfig(config)
        emojiReactionAnimation(
          data.bgColor,
          "heart-icon"
        )

        meetingClient?.showLike(data.bgColor, localUserProperties?.id)
      } else if (
        config === "" &&
        localUserProperties?.type === UserType?.MODERATOR &&
        profileImageUrl !== ""
      ) {
        emojiReactionAnimation("red", "heart-icon")

        meetingClient?.showLike("red", localUserProperties?.id)
      } else {
        emojiReactionAnimation(
          localUserProperties?.color,
          "heart-icon"
        )

        meetingClient?.showLike(
          localUserProperties?.color,
          localUserProperties?.id
        )
      }
    },
    [
      config,
      localUserProperties?.type,
      localUserProperties?.id,
      localUserProperties?.color,
      profileImageUrl,
      emojiReactionAnimation,
      meetingClient
    ]
  )

  const heightMobileHeartIcon = React.useMemo(() => {
    if (isModPresentVideo) {
      return isLandscape
        ? "2rem"
        : changeSizeIconDependingHeightVideo &&
            `${changeSizeIconDependingHeightVideo(30, 37)}px`
    }
    return isLandscape ? "1.5rem" : "2rem"
  }, [changeSizeIconDependingHeightVideo, isLandscape, isModPresentVideo])

  const stylesDesktopHeartIcon: React.CSSProperties = React.useMemo(() => {
    return {
      marginBottom: "10px"
    }
  }, [])

  return (
    <div id="heart-icon">
      {showIcon && (
        <>
          {isMobile ? (
            <IconButton
              width={"1.9rem"}
              height={heightMobileHeartIcon}
              isMobile={isMobile}
              alignItems={/* !isTransparent ? "besline" :  */ "center"}
              onClick={handleLike}
              style={{
                marginBottom: isLandscape && isModPresentVideo && "8px"
              }}
              {...addHitAreaStyle({left: 5, right: 5, top: 0, bottom: 0})}
            >
              <StyledHeartIcon
                id="heart-icon"
                roomStyles={roomStyles}
                size="1.9em"
                issmall={"true"}
                onMouseDown={e => e.preventDefault()}
                className="icon-ios"
              />
            </IconButton>
          ) : (
            <StyledHeartIcon
              id="heart-icon"
              onClick={handleLike}
              roomStyles={roomStyles}
              size="1.9em"
              width="1.9rem"
              onMouseDown={e => e.preventDefault()}
              className="icon-ios"
              style={stylesDesktopHeartIcon}
            />
          )}
        </>
      )}
    </div>
  )
}
